import { useRef, useState } from 'react';

import { FormHandles } from '@unform/core';
import { Form } from '@unform/web';
import { useTranslation } from 'react-i18next';
import { useHistory } from 'react-router-dom';
import { toast } from 'react-toastify';

import { ImageLogo } from '~/assets/images';
import { Input, Button, Checkbox } from '~/components';

import { useAuth } from '../../hooks/auth.context';
import {
  UserSignInDataSchema,
  IUserSignInData,
} from '../../services/auth.service';
import { handleYupValidationError } from '../../utils';

// Assets

import {
  BackgroundContainer,
  Container,
  Title,
  RememberMeLink,
  RememberMeText,
  RememberMeContainer,
} from './styled';

interface ILogin extends IUserSignInData {
  remember_session: boolean;
}

const Home = () => {
  const { signIn, setSessionPersistence } = useAuth();
  const [loading, setLoading] = useState(false);

  const formRef = useRef<FormHandles>(null);
  const { t } = useTranslation(['Home']);
  const history = useHistory();

  const handleSubmit = async (data: ILogin) => {
    try {
      formRef.current?.setErrors({});
      await UserSignInDataSchema.validate(data as IUserSignInData, {
        abortEarly: false,
      });
      setLoading(true);
      const result = await signIn(data as IUserSignInData);
      if (result.type === 'sucess') {
        toast.success(result.message);
        setSessionPersistence(data.remember_session);
        history.push('/users');
      } else {
        toast.error(result.message);
        setLoading(false);
      }
    } catch (err) {
      handleYupValidationError(formRef, err);
    }
  };

  return (
    <>
      <BackgroundContainer>
        <Container>
          <ImageLogo />
          <Title>{t('Home:title')}</Title>
          <Form ref={formRef} onSubmit={handleSubmit}>
            <Input
              name="email"
              placeholder={t('Home:email_placeholder')}
              containerStyle={{
                marginBottom: 22,
              }}
            />

            <Input
              name="password"
              showIconPassword
              placeholder={t('password_placeholder')}
            />

            <RememberMeContainer>
              <div>
                <Checkbox name="remember_session" />
                <RememberMeText>Lembrar de mim</RememberMeText>
              </div>
              <RememberMeLink to="/">Esqueci minha senha</RememberMeLink>
            </RememberMeContainer>
            <Button
              textContent={t('Home:button')}
              letterSpacing
              loading={loading}
              buttonDisable={loading}
              extraStyles={{
                maxWidth: 387,
                margin: 'auto',
              }}
              type="submit"
            />
          </Form>
        </Container>
      </BackgroundContainer>
    </>
  );
};

export default Home;
